import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Loader2, Files, Download } from "lucide-react";
import api from "@/lib/api";

// Opens all documents of an application as one PDF (`path`: the API endpoint that builds it).
export default function AllDocumentsButton({ path }) {
  const { t } = useTranslation();
  const [combining, setCombining] = useState(false);

  const open = async () => {
    setCombining(true);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      toast.error(t("admin.detail.all_documents_failed"));
    } finally {
      setCombining(false);
    }
  };

  return (
    <button onClick={open} disabled={combining} className="w-full flex items-center gap-3 rounded-lg p-4 mb-4 text-left bg-primary text-primary-foreground hover:bg-primary/90 transition-colors disabled:opacity-70" data-testid="all-documents-btn">
      <div className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 bg-primary-foreground/15">
        {combining ? <Loader2 className="w-5 h-5 animate-spin" /> : <Files className="w-5 h-5" strokeWidth={1.5} />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">{t("admin.detail.all_documents")}</p>
        <p className="text-xs opacity-80">{combining ? t("admin.detail.preparing") : t("admin.detail.all_documents_hint")}</p>
      </div>
      <Download className="w-4 h-4 shrink-0 opacity-80" />
    </button>
  );
}
